import React from 'react';
import { UserAdd } from '@wix/wix-ui-icons-common';
import { ComposerButtonProps } from '.';

// This object should contain a mock value for each required prop of this component
export const requiredProps: ComposerButtonProps = {
  label: 'Label',
  children: <UserAdd />,
};

// This array should contain an object only for tests you wish to run on all compliance tests
const sharedTests = [
  {
    title: 'render',
    props: {
      ...requiredProps,
    } as ComposerButtonProps,
  },
];

export const testkitTests = [...sharedTests];

export const ssrTests = [...sharedTests];

export const a11yTests = [...sharedTests];
